import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import button from '@/components/FcButton'
import { Toast, Dialog } from 'vant'
import { ImagePreview } from 'vant'
import moment from 'moment'
import 'vant/lib/index.css'
import './style/index.scss'

Vue.use(Vant)
Vue.config.productionTip = false
Vue.component('fcButton', button)// 自定义按钮
// 事件总线
Vue.prototype.$bus = new Vue()
Vue.prototype.$getUserKey = () => {
  return new Promise((resolve, reject) => {
    window.jsqcore.getUserKey({
      data: {},
      success: res => {
        try {
          resolve(res)
        } catch (e) {
          reject(e)
        }
      },
      fail: err => {
        reject(err)
      }
    })
  })
}
Vue.prototype.$closePage = () => {
  return new Promise((resolve, reject) => {
    window.jsqcore.closePage({
      data: {},
      success: res => {
        try {
          resolve(res)
        } catch (e) {
          reject(e)
        }
      },
      fail: err => {
        reject(err)
      }
    })
  })
}
Vue.prototype.$park_time = (time) => {
  const t1_0 = parseInt(time / 1440)
  const t1_1 = time % 1440
  const t2_0 = parseInt(t1_1 / 60)
  const t2_1 = t1_1 % 60
  return t1_0 + '天' + t2_0 + '小时' + t2_1 + '分'
}
Vue.prototype.$Dialog = Dialog
Vue.prototype.$moment = moment
Vue.prototype.$moment_s = (time) => { return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss') }
Vue.prototype.$moment_d = (time) => { return moment(time * 1000).format('YYYY-MM-DD') }
Vue.prototype.$Toast = Toast
Vue.prototype.$ImgPreview = ImagePreview
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
